import { render, staticRenderFns } from "./PartRequestStatusBadge.vue?vue&type=template&id=1edd3ee0"
import script from "./PartRequestStatusBadge.vue?vue&type=script&lang=ts"
export * from "./PartRequestStatusBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports